import React, { useEffect, useRef, useState } from "react"
import { Card, CardBody } from "reactstrap"
import PropTypes from "prop-types"
import SmallLoader from "../../Common/SmallLoader"
import CrossIcon from '../../../assets/images/lystfacelogos/CrossIcon.svg'
import { BackButton } from "../../Common/SvgIcons"
import { error } from "toastr"


const VerificationHelper = props => {
  const inputs = useRef([]);
  const verificationfromAdminPanel = props?.fromRoute === "email" || props?.fromRoute === "phone" || props?.fromRoute === "two-factor-auth"

  useEffect(() => {
    if (props?.resendTimeLeft === 30) {
      inputs.current[0]?.focus();
    }
  }, [props?.resendTimeLeft]);

  const handleChange = (e, index) => {
    props.setErrorStatus({ ...props.errorDetails, message: null, error: false });
    let value = e.target.value;

    // Only allow single digit input
    if (value.length > 1) {
      value = value.slice(-1);
    }

    if (value.match(/^\d$/)) {
      const newOtp = [...props?.otp];
      newOtp[index] = value;
      props.setOtp(newOtp);

      // Move focus to the next input
      if (index < props?.otpLength - 1) {
        inputs.current[index + 1].focus();
      }
    }

    // Move focus to previous input on backspace
    if (value === '' && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      props.setErrorStatus({ ...props.errorDetails, message: null, error: false });
      e.preventDefault(); // Prevent default backspace behavior

      const newOtp = [...props.otp];

      // Clear the current input value
      newOtp[index] = '';
      props.setOtp(newOtp);

      // Move focus to the previous input only if the current input is empty
      if (index > 0) {
        inputs.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (e, index) => {
    props.setErrorStatus({ ...props.errorDetails, message: null, error: false });
    const pastedData = e.clipboardData.getData('Text');
    const pastedOtp = pastedData.split('').filter((char) => /^\d$/.test(char)); // Only keep digits

    if (pastedOtp.length > 0) {
      const newOtp = [...props?.otp];

      // Loop through pasted digits and insert them starting from the current index
      pastedOtp.forEach((digit, i) => {
        const targetIndex = index + i;
        if (targetIndex < props?.otpLength) {
          newOtp[targetIndex] = digit;
        }
      });

      props?.setOtp(newOtp);

      // Move focus to the last filled input or the last input
      const nextFocusIndex = Math.min(index + pastedOtp.length, props?.otpLength - 1);
      inputs.current[nextFocusIndex].focus();
    }

    e.preventDefault(); // Prevent default paste behavior
  };



  const ResendLink = () => {
    props.resend()
  }
  return (
    <div className={`auth-form-container ${verificationfromAdminPanel ? "settings" : ""}`}>
      <Card>
        <CardBody>
          <div className="reset-link-container">
            {(props?.from === "verify-email") &&
              <>

                <div className={`main-text verify ${verificationfromAdminPanel ? "settings" : "back-button"}`}>
                  {(!verificationfromAdminPanel) && <div className="close-icon" onClick={props?.handleBackClick}>{BackButton}</div>}

                  <div>{props.title}</div>
                  {(verificationfromAdminPanel) && <div className="close-icon" onClick={props?.handleClose}><img src={CrossIcon} /></div>}

                </div>
              </>

            }
            {props?.isLogo && <img src={props.imgsrc} className="link-image" />}
            {(props?.from !== "verify-email") &&
              <div className="main-text">{props.title}</div>

            }
            <div className={`sub-text ${props?.fromRoute === "two-factor-auth" ? "two-factor" : ""}`}>{props.subtitle}</div>
            <div>
              {
                (props?.from === "verify-email") &&
                <div className="otp-container">
                  {props?.otp?.map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      value={props?.otp[index]}
                      onChange={(e) => handleChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      ref={(el) => (inputs.current[index] = el)}
                      className={`otp-input ${props?.errorDetails?.error ? "error" : ""}`}
                      onPaste={(e) => handlePaste(e, index)} // Pass index to handlePaste
                    />
                  ))}

                </div>

              }
              <div className="error-message">
                {(props?.errorDetails?.message) &&
                  <p >Invalid OTP</p>
                }
              </div>
              <div className={`sub-text2 ${(props?.from === "verify-email") ? "verify" : ""}`}>
                {
                  (props?.from === "verify-email") ?
                    <div>Didn’t received a code? </div>
                    :
                    <div>Didn't receive the email? </div>



                }
                {props.loading ? (
                  <div className="ms-1">
                    <SmallLoader />
                  </div>
                ) :
                  (props?.from !== "verify-email") ?
                    <div
                      className="click-resend link"
                      onClick={ResendLink}
                    >
                      Click to resend
                    </div>
                    :
                    !props?.resendTimeLeft ?
                      <div
                        className="click-resend link"
                        onClick={ResendLink}
                      >
                        Resend code
                      </div>
                      :
                      <div
                        className="click-resend"
                      >
                        Resend in {props?.resendTimeLeft}sec
                      </div>
                }
              </div>
              {
                props?.checkboxContent &&
                <>
                  <div className={`sub-text2 ${props?.checkboxContent ? "verify" : ""}`}>
                    <div
                      className="terms-condition-input">
                      <input
                        className="checkbox-icon"
                        type="checkbox"
                        name="terms"
                        id="termsCheckbox"
                        onClick={props.handleCheckBox}
                      />

                      <label
                        htmlFor="termsCheckbox"
                        className="checkbox-label"
                      > <div className={`checkbox-input ${props?.errorDetails?.checkBoxError ? "error" : ""}`}></div>
                        <span>
                          {props?.checkboxContent} <span className="error">*</span>
                        </span></label>

                    </div>
                  </div>
                  {(props?.errorDetails?.checkBoxError && !props?.isChecked) &&

                    <div className="error-message">
                      <p >*This checkbox is required.</p>

                    </div>
                  }
                </>
              }


            </div>
            {(verificationfromAdminPanel) &&
              <div className="bottom-line"></div>}
            {
              (props?.from === "verify-email") &&
              <button
                className={`background-button ${verificationfromAdminPanel ? "settings" : ""} ${props?.otp?.join('')?.length < 6 ? "disabled" : ""}`}
                disabled={props?.isVerifyLoading || props?.otp?.join('')?.length < 6}
                onClick={props?.onClickSubmit}
              > {props?.isVerifyLoading ? <SmallLoader /> : props?.buttonText ? props?.buttonText : "Verify OTP"}</button>
            }
            {props?.isTryOtherOptions &&
              <div className={`sub-text2 ${(props?.from === "verify-email") ? "try-other-options" : ""}`}>
                <div
                  className="click-resend link"
                  onClick={() => props?.handleClickTryOtherOptions(true)}
                >
                  Try other options
                </div>
              </div>
            }






          </div>
        </CardBody>
      </Card>
    </div >
  )
}

export default VerificationHelper

VerificationHelper.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  imgsrc: PropTypes.string,
  resend: PropTypes.any,
  loading: PropTypes.bool,
}
